export const hasAdminAuth = function () {
    try {
        const userInfo = localStorage.getItem('userInfo')
        const userInfoObj = JSON.parse(userInfo)
        return userInfoObj.user.userType === 1
    } catch (error) {
        console.log(error)
        return false
    }
}
